import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "import-limit",
  "use": "import-limit-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"import-limit\"><title>Import Limit</title><g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1 8v3.802h11V8M8.621 5.5L6.5 7.621 4.379 5.5M8.621 1.5L6.5 3.621 4.379 1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/import-limit.svg
// module id = 522
// module chunks = 0